import NotificationsSettingsIcon from "../../assets/svg/SideNav/NotificationsSettingsIcon";
import NotificationsForm from "../../components/organism/NotificationsPage/NotificationsForm";
import NotificationsList from "../../components/NotificationsScreen/NotificationsList";
import { useHistory } from "react-router-dom";
import useNotificationsList from "../../services/utils/custom hooks/Notifications/useNotificationsList";
import { useContext, useEffect, useState } from "react";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import AdminContentLayout from "../../layouts/AdminContentLayout";
import useProfile from "../../services/utils/custom hooks/useProfile";
import Button from "../../components/organism/Button";
import dataConstants from "../../constants/dataConstants";
import InfoSliderDispatcher from "../../components/molecular/InfoSliderDispatcherButton";

function NotificationSettingsButton(): JSX.Element {
  const history = useHistory();
  const profile: any = {};
  // const { profile } = useSelector((state: any) => state.Profile);
  return (
    <button
      type="button"
      className="flex justify-between items-center"
      onClick={() => {
        profile?.roles?.includes("Office Manager")
          ? history.push("/notifications/settings/organization-settings")
          : history.push("/notifications/settings/personal-settings");
      }}
    >
      <p className="font-normal">Notifications Settings</p>
      <NotificationsSettingsIcon className="ml-3.5" />
    </button>
  );
}

function NotificationPage(): JSX.Element {
  const history = useHistory();
  const [params, setParams] = useState<string>("");
  const [filters, setFilters] = useState({});
  const profile = useProfile();
  const isPhysicianOnly =
    profile?.data?.user?.roles?.includes("Physician") &&
    profile?.data?.user?.roles?.length === 1;
  const {
    data: notificationsList,
    isLoading,
    isError,
  } = useNotificationsList({ params });
  const { dispatch } = useContext(ApplicationState);

  useEffect(() => {
    dispatch({ type: "RESET_NOTIFICATION_COUNT" });
  }, []);

  return (
    <AdminContentLayout
      pageTitle="Notifications | CSTL"
      subHeaderTitle="Notifications"
      customButtons={[
        {
          buttonTheme: "transparent",
          textInformation: {
            text: "Notifications Settings",
            fontWeight: "font-normal",
          },
          className: "md:mx-5 mx-3 capitalize",
          onClick: () => {
            isPhysicianOnly
              ? history.push("/access/notifications/settings/personal-settings")
              : history.push(
                  "/access/notifications/settings/organizations-settings"
                );
          },
        },
      ]}
    >
      <div className="overflow-visible h-[100vh]">
      <div className="py-6 md:px-5 px-3 bg-white ">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <p className="font-bold md:text-2xl text-xl font-royalBlue">Notifications</p>

            <InfoSliderDispatcher
              infoQuery={dataConstants.infoSliderQuery.notifications}
            />
          </div>
          <Button
            type="button"
            buttonTheme="transparent"
            textInformation={{
              text: "Notifications Settings",
              fontWeight: "font-normal",
              fontSize:"md:text-base text-sm"
            }}
            className=" block md:hidden ml-3 capitalize text-left w-full"
            onClick={() => {
              isPhysicianOnly
                ? history.push(
                    "/access/notifications/settings/personal-settings"
                  )
                : history.push(
                    "/access/notifications/settings/organizations-settings"
                  );
            }}
          />
        </div>
        <NotificationsForm setParams={setParams} setFilters={setFilters} />
      </div>

      <div className="pb-36 mx-5 max-h-100vh overflow-y-auto">
        <NotificationsList
          notificationsList={notificationsList?.data ?? []}
          fetchingNotifications={isLoading}
          fetchingNotificationsError={isError}
          filters={filters}
        />
      </div>
      </div>
    </AdminContentLayout>
  );
}

export default NotificationPage;
